import { IOci } from '@/contract/oci.contract';
import Axios from 'axios';
import { Constants } from '../constants';

class MasterdataApiService {
  public async getOcis(): Promise<IOci[]> {
    const axiosResult = await Axios.get<IOci[]>(`${Constants.ApiBaseUrl}ocis`);
    return axiosResult.data;
  }
}

export const masterdataApiService = new MasterdataApiService();
